import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import {
  FormModal,
  getResponsibleManagersExceededNotification,
} from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { MODAL_HEADER_VARIANT } from '../../../Modal'

import {
  BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS,
  BUILDING_EDIT_MANAGERS_FORM_BODY_PROPS,
  QA_NAME_EDIT_MANAGERS_MODAL,
} from './BuildingsEditManagersActionModal.constants'
import {
  getInitialValues,
  getValidationSchema,
} from './BuildingsEditManagersActionModal.utils'
import { FormFields } from './FormFields'

function BuildingsEditManagersActionModal({
  formFieldsProps: {
    actionTypes = Object.values(getEntityActionTypeSelectOptions()),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  itemAction,
  users,
  onSubmit,
  ...restProps
}) {
  const { t } = useTranslation()

  const initialValues = getInitialValues({ itemAction, users })

  const validationSchema = getValidationSchema({ initialValues, itemAction })

  function handleSubmit({ values }) {
    const payload = {
      ids: getItemsIds(
        values[BUILDING_EDIT_MANAGERS_FIELD_NAME_MANAGERS],
        'value'
      ),
    }

    onSubmit({
      actionType: values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME],
      value: payload,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        qaName: QA_NAME_EDIT_MANAGERS_MODAL,
      }}
      formBodyProps={BUILDING_EDIT_MANAGERS_FORM_BODY_PROPS}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Modal.ChangeManagerTitleKey'
      initialNotifications={[getResponsibleManagersExceededNotification(t)]}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default BuildingsEditManagersActionModal
